// extracted by mini-css-extract-plugin
export default {"link":"link--p58mu"};